import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { LightningModalTypes } from '../../../../core/classes/modal-types.enum';

@Component({
  selector: 'app-apartment-request-dialog',
  templateUrl: './apartment-request-dialog.component.html',
  styleUrls: ['./apartment-request-dialog.component.scss'],
  standalone: false
})
export class ApartmentRequestDialogComponent {
  // Input
  public jrfReference: string = null;

  constructor(public activeModal: NgbActiveModal) {}
}

LightningModalTypes.ApartmentRequestDialogComponent.component = ApartmentRequestDialogComponent;
